// Brand-aware status pills — light tinted backgrounds with deep navy or teal text.
const COLORS = {
  started:                          ["#F1F5F9", "#475569"],
  incomplete:                       ["#FEF3C7", "#92400E"],
  submitted:                        ["#E0F2F1", "#00838F"],
  under_objective_review:           ["#E0E7FF", "#3730A3"],
  waiting_for_documents:            ["#FEF3C7", "#92400E"],
  waiting_for_reference_responses:  ["#FEF3C7", "#92400E"],
  qualified_for_interview:          ["#CFFAFE", "#0E7490"],
  interview_scheduled:              ["#00A7B5", "#FFFFFF"],
  selected:                         ["#0B2D59", "#FFFFFF"],
  waitlisted:                       ["#E2EBF1", "#0B2D59"],
  not_selected:                     ["#FEE2E2", "#B91C1C"],
  withdrawn:                        ["#F1F5F9", "#475569"],
  closed:                           ["#E2E8F0", "#475569"],
};

export default function StatusBadge({ status }) {
  const [bg, fg] = COLORS[status] || ["#F1F5F9", "#475569"];
  return (
    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold capitalize"
      style={{ background: bg, color: fg }}>
      {(status || "—").replaceAll("_", " ")}
    </span>
  );
}
